import React, {Component} from 'react';
import {connect} from "react-redux";

import {
  isChildAttr,
  getFlattenAttrs,
  getAttrLink,
  getSummary,
  getAttrOptionsByParams,
  getOptionsDeliveryTime
} from "../../helpers/attributes";
import {addToCart, getProductId} from "../../helpers/common";
import analytics from "../../helpers/analytics";

import Navigation from "../Navigation";

class NavigationSummary extends Component {

  addToCart = () => {

    const {attributes, previewImage, params, params: {'edit-key': editKey = false}} = this.props,
      selectedOptions = getAttrOptionsByParams(attributes, params),
      optionsDeliveryTime = getOptionsDeliveryTime(selectedOptions);

    addToCart({
      summary: getSummary(attributes, params),
      productId: getProductId(),
      tableImg: previewImage,
      editKey: editKey,
      deliveryTime: optionsDeliveryTime
    })
      .then(response => {

        // Analytics
        analytics.onAddToCart();

        if (process.env.NODE_ENV === 'production') {
          window.location = response.data;
        } else {
          alert('Product was added to cart.');
        }

      })
      .catch(error => {
        // Error message
        alert(error.response.data);
      });

  };

  render() {

    const {attributes: rawAttributes, match, params, ...rest} = this.props,
      attributes = getFlattenAttrs(rawAttributes);

    let prevAttr = attributes[attributes.length - 1];

    if (isChildAttr(prevAttr) && params[prevAttr.parent].price === 0) {
      prevAttr = rawAttributes[rawAttributes.length - 1];
    }

    return (
      <Navigation
        prevLink={getAttrLink(prevAttr.slug)}
        handleNext={this.addToCart}
        nextText="Mit Bestellung fortfahren"
        {...rest}
      />
    );

  }
}

export default connect(
  state => ({
    attributes: state.attributes,
    params: state.params,
    previewImage: state.previewImage
  })
)(NavigationSummary);
